module.exports = __webpack_public_path__ + "media/images/new_default_icon-bc7f11b2.png";